import { useEffect, useState } from 'react'
import DualListBox from 'react-dual-listbox'
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft'
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft'
import { PermissionResource } from '@/types/permissions.types'
import 'react-dual-listbox/lib/react-dual-listbox.css'
import './DualList.styles.css'

import CustomView from './CustomView'

const mockedOptions = [
  {
    type: PermissionResource.ACCOUNT,
    values: ['Ler', 'Inserir', 'Atualizar', 'Excluir']
  },
  {
    type: PermissionResource.ACCESSORY,
    values: ['Ler', 'Inserir', 'Atualizar', 'Excluir']
  },
  {
    type: PermissionResource.MANAGEMENT_ANALYSIS,
    values: ['Ler', 'Inserir', 'Atualizar', 'Excluir']
  },
  {
    type: PermissionResource.BREAKDOWN,
    values: ['Ler', 'Inserir', 'Atualizar', 'Excluir']
  },
  {
    type: PermissionResource.CATEGORY,
    values: ['Ler', 'Inserir', 'Atualizar', 'Excluir']
  },
  {
    type: PermissionResource.TCO_CATEGORY,
    values: ['Ler', 'Inserir', 'Atualizar', 'Excluir']
  },
  {
    type: PermissionResource.INSPECTION_CATEGORY,
    values: ['Ler', 'Inserir', 'Atualizar', 'Excluir']
  },
  {
    type: PermissionResource.COST_CENTER,
    values: ['Ler', 'Inserir', 'Atualizar', 'Excluir']
  },
  {
    type: PermissionResource.CITY,
    values: ['Ler', 'Inserir', 'Atualizar', 'Excluir']
  },
  {
    type: PermissionResource.DEALERSHIP,
    values: ['Ler', 'Inserir', 'Atualizar', 'Excluir']
  },
  {
    type: PermissionResource.DASHBOARD,
    values: ['Ler', 'Inserir', 'Atualizar', 'Excluir']
  },
  {
    type: PermissionResource.DASHBOARD_MANAGEMENT_ANALYSIS,
    values: ['Ler', 'Inserir', 'Atualizar', 'Excluir']
  },
  {
    type: PermissionResource.BOARD,
    values: ['Ler', 'Inserir', 'Atualizar', 'Excluir']
  },
  {
    type: PermissionResource.APPRAISAL_COMPANY,
    values: ['Ler', 'Inserir', 'Atualizar', 'Excluir']
  },
  {
    type: PermissionResource.ADDRESS,
    values: ['Ler', 'Inserir', 'Atualizar', 'Excluir']
  },
  {
    type: PermissionResource.STATE,
    values: ['Ler', 'Inserir', 'Atualizar', 'Excluir']
  },
  {
    type: PermissionResource.FILE_MANAGER,
    values: ['Ler', 'Inserir', 'Atualizar', 'Excluir']
  },
  {
    type: PermissionResource.CATEGORY_GROUP,
    values: ['Ler', 'Inserir', 'Atualizar', 'Excluir']
  },
  {
    type: PermissionResource.ITEM_SERIES,
    values: ['Ler', 'Inserir', 'Atualizar', 'Excluir']
  },
  {
    type: PermissionResource.BRAND,
    values: ['Ler', 'Inserir', 'Atualizar', 'Excluir']
  },
  {
    type: PermissionResource.MODEL,
    values: ['Ler', 'Inserir', 'Atualizar', 'Excluir']
  },
  {
    type: PermissionResource.PHOTO_FLOW_PARAMETRIZATION,
    values: ['Ler', 'Inserir', 'Atualizar', 'Excluir']
  },
  {
    type: PermissionResource.INSPECTION_PHOTO_PARAMETRIZATION,
    values: ['Ler', 'Inserir', 'Atualizar', 'Excluir']
  },
  {
    type: PermissionResource.PHOTO_SECTION_PARAMETRIZATION,
    values: ['Ler', 'Inserir', 'Atualizar', 'Excluir']
  },
  {
    type: PermissionResource.EVALUATION_TYPE_PARAMETRIZATION,
    values: ['Ler', 'Inserir', 'Atualizar', 'Excluir']
  },
  {
    type: PermissionResource.INSPECTION_PARAMETRIZATION,
    values: ['Ler', 'Inserir', 'Atualizar', 'Excluir']
  },
  {
    type: PermissionResource.PROFILE,
    values: ['Ler', 'Inserir', 'Atualizar', 'Excluir']
  },
  {
    type: PermissionResource.PRECIFICATION,
    values: ['Ler', 'Inserir', 'Atualizar', 'Excluir']
  },
  {
    type: PermissionResource.PREPARATION,
    values: ['Ler', 'Inserir', 'Atualizar', 'Excluir']
  },
  {
    type: PermissionResource.PROVIDER,
    values: ['Ler', 'Inserir', 'Atualizar', 'Excluir']
  },
  {
    type: PermissionResource.PRODUCT,
    values: ['Ler', 'Inserir', 'Atualizar', 'Excluir']
  },
  {
    type: PermissionResource.OWNER,
    values: ['Ler', 'Inserir', 'Atualizar', 'Excluir']
  },
  {
    type: PermissionResource.REFUND,
    values: ['Ler', 'Inserir', 'Atualizar', 'Excluir']
  },
  {
    type: PermissionResource.SERVICE,
    values: ['Ler', 'Inserir', 'Atualizar', 'Excluir']
  },
  {
    type: PermissionResource.SLA,
    values: ['Ler', 'Inserir', 'Atualizar', 'Excluir']
  },
  {
    type: PermissionResource.UNIT_MEASURE,
    values: ['Ler', 'Inserir', 'Atualizar', 'Excluir']
  },
  {
    type: PermissionResource.USER,
    values: ['Ler', 'Inserir', 'Atualizar', 'Excluir', 'Aprovar']
  },
  {
    type: PermissionResource.VEHICLE,
    values: ['Ler', 'Inserir', 'Atualizar', 'Excluir']
  },
  {
    type: PermissionResource.INSPECTION,
    values: ['Ler', 'Inserir', 'Atualizar', 'Excluir', 'Avaliar']
  },
  {
    type: PermissionResource.INSPECTION_ACCESSORY,
    values: ['Ler', 'Inserir', 'Atualizar', 'Excluir']
  },
  {
    type: PermissionResource.INSPECTION_BREAKDOWN,
    values: ['Ler', 'Inserir', 'Atualizar', 'Excluir']
  },
  {
    type: PermissionResource.INSPECTION_PHOTO,
    values: ['Ler', 'Inserir', 'Atualizar', 'Excluir']
  },
  {
    type: PermissionResource.INSPECTION_ITEM_SERIES,
    values: ['Ler', 'Inserir', 'Atualizar', 'Excluir']
  },
  {
    type: PermissionResource.INSPECTION_REPORT,
    values: ['Ler', 'Inserir', 'Atualizar', 'Excluir']
  },
  {
    type: PermissionResource.VALOR_RESIDUAL,
    values: ['Ler', 'Atualizar']
  },
  {
    type: PermissionResource.INTEGRACOES,
    values: ['Ler', 'Executar']
  },
  {
    type: PermissionResource.MARGEM,
    values: ['Ler']
  },
  {
    type: PermissionResource.INSPECTION_BACKOFFICE,
    values: ['Inserir', 'Atualizar']
  },
  {
    type: PermissionResource.INSPECTION_CR_HISTORY,
    values: ['Ler']
  }
]

interface Props {
  profilePermissions?: any[]
  handleSelectedPermissions: (list: any) => void
  disabled: boolean
}
function DualList({
  profilePermissions,
  handleSelectedPermissions,
  disabled
}: Props) {
  const [selected, setSelected] = useState<any[]>([])
  const [dualListOptions, setDualListOptions] = useState([])

  useEffect(() => {
    const options: any = mockedOptions.map((item) => ({
      label: item.type,
      options: item.values.map((value) => ({
        value: `${item.type}_${value}`,
        label: value
      }))
    }))

    setDualListOptions(options)
  }, [])

  useEffect(() => {
    if (profilePermissions?.length) {
      const current: any[] = []
      profilePermissions.forEach((item) => {
        const { type, values } = item
        values.forEach((value: any) => {
          const mockedOption = mockedOptions.find(
            (option) => option.type === type
          )

          if (mockedOption) {
            const valueAction = mockedOption.values.filter(
              (mockedValue) => mockedValue === value
            )
            if (valueAction) current.push(`${type}_${valueAction}`)
          }
        })
      })

      setSelected(current)
    }
  }, [profilePermissions])

  useEffect(() => {
    handleSelectedPermissions(selected)
  }, [selected])

  return (
    <CustomView>
      <DualListBox
        disabled={disabled}
        options={dualListOptions}
        icons={{
          moveToAvailable: <KeyboardArrowLeftIcon />,
          moveAllToAvailable: <KeyboardDoubleArrowLeftIcon />,
          moveToSelected: <KeyboardArrowRightIcon />,
          moveAllToSelected: <KeyboardDoubleArrowRightIcon />
        }}
        selected={selected}
        onChange={(value) => setSelected(value)}
      />
    </CustomView>
  )
}

export default DualList
